import React from "react";
import { Button, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./ServicDetails.css";
const ServiceDetails = ({ picture }) => {
  const { name, details, images, price } = picture;
  const navigate = useNavigate();
  const handelButton = () => {
    navigate("/addtocart");
  };
  return (
    <div id="services">
      <Card className="card crd">
        <div className="image">
          <Card.Img variant="top" src={images} />
        </div>
        <Card.Body>
          <p>${price}</p>
          <Card.Title>{name}</Card.Title>
          <Card.Text>DETAILS: {details}</Card.Text>
          <Button className="w-100" onClick={handelButton} variant="primary">
            ADD to cart
          </Button>
        </Card.Body>
      </Card>
    </div>
  );
};

export default ServiceDetails;
